<template>
	<v-app>
		<v-content>
			<v-container class="fill-height" fluid>
				<div class="rule">
					<h1>LINEミニアプリプライバシーポリシー</h1>
					<dl class="dl-block">
            <p>株式会社USENが本サービス（LINEミニアプリ）を{{corporate_name}}にシステム提供しています。 本サービス（LINEミニアプリ）を提供するにつき、株式会社USENのドメインにて{{corporate_name}}の公式プライバシーポリシーを作成しています。 </p>
            <dd>
              <ul>
                <li style="list-style-type: none">&lt;サービス事業主&gt;</li>
                <li style="list-style-type: none">岡山県倉敷市笹沖４１０−５</li>
                <li style="list-style-type: none">{{corporate_name}}</li>
              </ul>
            </dd>
            <br>

						<p>{{corporate_name}} (以下「当社」といいます。)は、当社の提供するサービス(以下「本サービス」といいます。)における、お客様についての個人情報を含む利用者情報の取扱いについて、以下のとおりプライバシーポリシー(以下「本ポリシー」といいます。)を定めます。なお、本ポリシーにおいて別段の定めがない限り、本ポリシーにおける用語の定義は、個人情報の保護に関する法律(以下「個人情報保護法」といいます。)及び別途利用規約の定めに従います。</p>
						<dt>第1条 個人情報の取り扱いについて</dt>
						<dd>
						<ol>
						<li>当社および開発会社において、個人情報は、本サービスの開発・販売・運営業務における当社の正当な事業遂行上必要な範囲に限定して、取得・利用及び提供をし、特定された利用目的の達成に必要な範囲を超えた個人情報の取扱い（目的外利用）を行いません。また、目的外利用を行わないための措置を講じます。</li>
						<li>当社は、個人情報及び匿名加工情報の取り扱いに関し、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）及び関連する政令、規則、ガイドライン等を遵守します。</li>
						<li>
                        当社は、本ポリシー及び個人情報等の取扱いを継続的に改善するよう努めます。
						</li>
						</ol>
						</dd>
						
						<dt>第2条 収集する利用者情報及び収集方法</dt>
						<dd>
						<ol>
						<li>本サービスは、LINE株式会社が提供するアプリケーション「LINE MINI App（ラインミニアプリ）」（以下「LINEアプリ」といいます。）のプラットフォームを利用します。お客様は[LINEプライバシーポリシー(https://terms.line.me/line_rules/?lang=ja)]に同意しなければ、本サービスを利用することができません。お客様が本サービスを利用した場合、LINEプライバシーポリシーにも同意したものとみなします。</li>
						<li>本ポリシーにおいて、「利用者情報」とは、お客様の識別に係る情報、通信サービス上の行動履歴、その他お客様のスマートフォン、PC等の端末においてお客様またはお客様の端末に関連して生成または蓄積された情報であって、本ポリシーに基づき当社が収集するものを意味するものとします。</li>
						<li>
                        当社は、LINEアプリを通じてお客様の利用者情報を取得します。
						</li>
						</ol>
						</dd>

						<dt>第3条 お客様からご提供いただく情報</dt>
						<dd>
						本サービスを利用するために、または本サービスの利用を通じてお客様からご提供いただく情報は、LINEアプリが定める方法を通じてお客様が入力または送信した情報で、以下の情報が含まれます。
						<br>(1)ユーザーIDおよびユーザー名
						<br>(2)お客様がご利用になった本サービスの内容、日時、回数、本サービスご利用時のお客様の挙動などのご利用内容・履歴・状況に関する情報
						<br>(3)その他LINEアプリで取得される、お客様に関する一切の情報
						<br>(4)お客様が本サービスのご利用において、他のサービスと連携を許可することにより、当該他のサービスからご提供いただく情報
						</dd>

						<dt>第4条 利用目的</dt>
						<dd>
                        本サービスの提供にかかわる利用者情報の具体的な利用目的は以下のとおりです。
                        <br>(1)本サービスのご提供のため
                        <br>(2)本サービスに関するご案内、お問合せ等への対応のため
                        <br>(3)本サービスに関する当社の規約、ポリシー等(以下「規約等」といいます。)に違反する行為への対応のため
                        <br>(4)当社または第三者が現在提供しているサービスまたは将来提供を検討しているサービスに関するマーケティング活動のため
                        <br>(5)商品およびサービスのご案内・サポート情報をご提供するため
                        <br>(6)利用者のトラフィック測定及び行動測定のため
                        <br>(7)本サービスに関連して、個人を識別できない形式に加工した統計データを作成するため
                        <br>(8)上記の利用目的に付随する利用目的のため
						</dd>

						<dt>第5条 第三者提供</dt>
						<dd>
                        当社は、利用者情報のうち、個人情報については、個人情報保護法その他法令に基づき第三者への提供が認められる場合を除くほか、あらかじめお客様の同意を得ないで、第三者に提供しません。ただし、次に掲げる場合はこの限りではありません。
                        <br>(1)お客様の同意がある場合
                        <br>(2)当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合
                        <br>(3)合併その他の事由による事業の承継に伴って、個人情報が提供される場合
                        <br>(4)国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合
                        <br>(5)その他、個人情報保護法その他の法令で認められる場合
						</dd>

						<dt>第６条 個人情報の開示・訂正</dt>
						<dd>お客様は当社に対して自己に関する保有個人データを開示するよう請求することができます。また、当社の保有するお客様の保有個人データに誤りや変更があった場合は訂正、追加又は項目削除を請求することができます。</dd>

						<dt>第７条 個人情報の管理およびセキュリティについて</dt>
						<dd>
                        当社では、収集させていただいた個人情報および利用者情報を、一般のユーザーがアクセスできない環境下にあるサーバーにて安全に保管し、不正アクセス・紛失・破壊・改ざんまたは漏洩が生じないよう努めます。
						</dd>

						<dt>第８条 未成年者の利用</dt>
						<dd>お客様が未成年者の場合、親権者または後見人が本ポリシーおよび利用規約等の内容に同意され、お客様が本ポリシーおよび利用規約等に基づき本サービスをご利用いただくことについて包括的に同意されることが必要となります。</dd>

						<div v-if="shop_email != null">
								<dt>第９条 お問い合わせ窓口</dt>
								<dd>
								保有個人データの開示・訂正・利用停止・第三者提供停止等のご請求、その他ご不明な点及び苦情につきましては下記までご連絡ください。<br>
								<p>
                                 会社名  {{corporate_name}}<br>
                                 問合せ先 {{shop_email}}
								</p>
								</dd>
						</div>
						<p class="si">2021年7月1日 施行</p>
					</dl>
				</div>

			</v-container>
		</v-content>
	</v-app>
</template>

<script>
export default {
	data: () => ({
			shop_name: null,
			shop_email: null,
			corporate_name: null,
			app_name: null,
			state:null,
			address1:null,
			address2:null,
			
  }),
  async created() {
    const shop_id = this.getUrlGetParam('shop_id')
    try {
      //ページ表示に必要な情報を取得
      var shopReq = { params: {
        sid: shop_id
      }}
      var shopRes = await this.apiCall('/user/shop', shopReq)

      this.shop_name = shopRes.shop_name;
      this.shop_email = shopRes.inquiry_mail;
      this.corporate_name = shopRes.corporate_name;
      this.app_name = shopRes.app_name;
      this.state = shopRes.state;
      this.address1 = shopRes.address1;
      this.address2 = shopRes.address2;

    } catch(e) {
      this.callDialog('エラー', shopRes.message, 3);
    }
  }
}
</script>

<style scoped>
h1 {
	font-family: YuGothic;
	font-weight: bold;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: #333;
	margin-bottom: 20px;
}

.rule {
	padding-top: 10px;
}

dl {
	font-size: 13px;
}

dt {
	font-family: YuGothic;
	font-weight: bold;
	font-size: 16px;
	text-align: center;
	color: #333;
	margin: 30px 0 10px;
}

.si {
	margin-top: 30px;
}
</style>
